import { ACTIVITY_EMOJIS } from './constants';

export function formatActivityWithEmoji(activity: string): string {
  const normalizedActivity = activity.toLowerCase().trim();
  const emoji = ACTIVITY_EMOJIS[normalizedActivity] || '🎯';
  return `${emoji} ${activity}`;
}